"use client";
// import { Provider } from "react-redux";
// import { store } from "lib/redux/store";
// import { Navbar } from "./Navbar";
// import Link from "next/link";
// import {
//   ArrowLongRightIcon,
//   DocumentPlusIcon,
// } from "@heroicons/react/24/outline";
// import AddResumeIcon from "public/assets/dashboardIcons/AddResumeIcon.svg";
// import PlusIcon from "public/assets/dashboardIcons/PlusIcon.svg";
// import DashboardResume from "./DashboardResume";
import Dashboard from "./Dashboard";

const DashboardContainer = () => {
  return <Dashboard />;
};

export default DashboardContainer;
